<template>
	<div class="h5-video-page">
		<div class="info" v-if="!isFullscreen">
			<div class="info-main">
				<div class="cate" v-if="cateName">{{ cateName }}</div>
				<div class="name" v-if="title">{{ title }}</div>
				<div class="sub" v-if="chapterLine">{{ chapterLine }}</div>
			</div>
			<img class="mine-btn" src="../../assets/images/my.png" alt="返回个人中心" @click="toMine" />
		</div>
		<div class="player-area">
			<div
				class="player-wrap"
				:class="{ 'is-fullscreen': isFullscreen }"
				v-if="videoUrl"
				ref="playerWrap"
				@click="toggleControls"
			>
				<video
					ref="videoPlayer"
					class="h5-video"
					:src="videoUrl"
					:poster="poster"
					playsinline
					webkit-playsinline="true"
					x5-playsinline="true"
					x5-video-player-type="h5-page"
					preload="auto"
					@timeupdate="onTimeUpdate"
					@loadedmetadata="onLoadedMetadata"
					@play="onPlay"
					@pause="isPlaying = false"
					@ended="onEnded"
					@click.stop="togglePlay"
				>
					抱歉，您的浏览器不支持视频播放
				</video>

				<div class="try-mask" v-if="showTryVideo">
					<div class="try-text">试看结束</div>
					<div class="try-text">如需继续观看，请前往购买</div>
				</div>

				<div class="desc-tip" v-show="showDescTip && !showTryVideo">
					{{ currentDesc }}
				</div>

				<div class="controls" :class="{ 'controls-show': showControls || isFullscreen }" @click.stop>
					<div class="controls-row">
						<div class="play-btn" @click="togglePlay">
							<span v-if="isPlaying">❚❚</span>
							<span v-else>▶</span>
						</div>
						<div class="time">{{ formatTime(currentTime) }}</div>
						<div class="progress-wrap" ref="progressWrap" @click="seekByClick">
							<div class="progress-bg">
								<div class="progress-bar" :style="{ width: progressPercent + '%' }"></div>
								<div
									v-for="(point, index) in points"
									:key="index"
									class="point-dot"
									:style="{ left: getPointLeft(point) + '%' }"
									@click.stop="seekToPoint(point)"
								></div>
							</div>
						</div>
						<div class="time">{{ formatTime(duration) }}</div>
						<div class="fs-btn" @click.stop="toggleFullscreen">
							{{ isFullscreen ? '退出' : '全屏' }}
						</div>
					</div>
				</div>
			</div>
			<div class="empty" v-else-if="loading">加载中...</div>
			<div class="empty" v-else>{{ emptyText }}</div>
			<img
				v-if="!isFullscreen"
				class="bottom-banner"
				src="../../assets/images/course/6d0065d87b5256d62afacef9249d6fbc.jpg"
				alt=""
			/>
		</div>
	</div>
</template>

<script>
	import { getChapterDetail, putUserChapter } from '@/api/course';

	export default {
		name: 'H5Video',
		data() {
			return {
				loading: false,
				videoUrl: '',
				poster: '',
				title: '',
				chapter: '',
				chapterTitle: '',
				cateName: '',
				emptyText: '暂无视频',
				points: [],
				isPlaying: false,
				isFullscreen: false,
				showControls: true,
				currentTime: 0,
				duration: 0,
				showDescTip: false,
				currentDesc: '',
				tooltipTimeout: null,
				controlsTimeout: null,
				triggeredPoints: {},
				useCssFullscreen: false,
				chapterId: '',
				token: '',
				trySeconds: 0,
				showTryVideo: false,
				isBuy: 0
			};
		},
		computed: {
			chapterLine() {
				const parts = [this.chapter, this.chapterTitle].filter(Boolean);
				return parts.join(' ');
			},
			progressPercent() {
				if (!this.duration) return 0;
				return Math.min(100, (this.currentTime / this.duration) * 100);
			}
		},
		mounted() {
			this.init();
			document.addEventListener('fullscreenchange', this.onFullscreenChange);
			document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
		},
		beforeDestroy() {
			this.clearTimers();
			document.removeEventListener('fullscreenchange', this.onFullscreenChange);
			document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
			this.unlockBodyScroll();
			this.exitDocumentFullscreen();
		},
		methods: {
			toMine() {
				const payload = { action: 'toMine' }
				const go = () => {
					const mp = window.wx && window.wx.miniProgram
					if (!mp) return
					if (typeof mp.postMessage === 'function') {
						mp.postMessage({ data: payload })
					}
					if (typeof mp.switchTab === 'function') {
						mp.switchTab({ url: '/pages/mine/mine' })
					}
				}
				if (window.wx && window.wx.miniProgram) {
					go()
					return
				}
				const script = document.createElement('script')
				script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
				script.onload = go
				document.head.appendChild(script)
			},
			decodeQuery(value) {
				if (!value) return '';
				try {
					return decodeURIComponent(value);
				} catch (e) {
					return value;
				}
			},
			resolveVideoUrl(detail) {
				if (!detail) return '';
				if (detail.file && detail.file.url) return detail.file.url;
				if (detail.fee_file && detail.fee_file.url) return detail.fee_file.url;
				if (detail.video && detail.video.url) return detail.video.url;
				return detail.video_url || detail.url || '';
			},
			async init() {
				const query = this.$route.query || {};
				this.title = this.decodeQuery(query.title);
				this.chapter = this.decodeQuery(query.chapter);
				this.chapterTitle = this.decodeQuery(query.chapterTitle || query.subTitle);
				this.cateName = this.decodeQuery(query.course_cate_name || query.courseCateName);
				this.poster = this.decodeQuery(query.poster);
				this.chapterId = query.chapterId || '';
				this.token = query.token || '';

				if (!query.chapterId) {
					this.emptyText = '缺少章节信息';
					return;
				}

				await this.loadChapter(query.chapterId, query.token);
			},
			async loadChapter(chapterId, token) {
				this.loading = true;
				this.emptyText = '暂无视频';
				try {
					const config = token ? { headers: { 'X-Access-Token': token } } : undefined;
					const { data } = await getChapterDetail({ uuid: chapterId }, config);
					const detail = (data && data.result) || {};

					if (detail.vis == 2 || detail.is_deleted == 2 || detail.course_is_deleted == 2) {
						this.videoUrl = '';
						this.emptyText = '章节不可观看';
						return;
					}

					this.title = this.title || detail.name || detail.course_name || '';
					this.chapter = this.chapter || (detail.sort ? `第${detail.sort}章` : '');
					this.chapterTitle = this.chapterTitle || detail.sub_title || detail.subtitle || '';
					this.poster = this.poster || (detail.img || (detail.file && detail.file.cover) || '');
					this.points = Array.isArray(detail.points) ? detail.points : [];
					this.isBuy = Number(detail.is_buy);
					const seconds = Number(detail.seconds);
					const needTry = this.isBuy != 1 && !isNaN(seconds) && seconds > 0;
					this.trySeconds = needTry ? seconds : 0;
					this.showTryVideo = false;
					this.videoUrl = this.resolveVideoUrl(detail);
					if (!this.videoUrl) {
						this.emptyText = '暂无视频';
						return;
					}
					this.$nextTick(this.prepareVideo);
				} catch (e) {
					this.videoUrl = '';
					this.emptyText = '视频加载失败';
				} finally {
					this.loading = false;
				}
			},
			prepareVideo() {
				const video = this.$refs.videoPlayer;
				if (!video) return;
				video.setAttribute('playsinline', 'true');
				video.setAttribute('webkit-playsinline', 'true');
				video.setAttribute('x5-playsinline', 'true');
				video.setAttribute('x5-video-player-type', 'h5-page');
				this.scheduleHideControls();
			},
			formatTime(seconds) {
				const s = Math.max(0, Math.floor(seconds || 0));
				const m = Math.floor(s / 60);
				const ss = s % 60;
				return `${String(m).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
			},
			getPointLeft(point) {
				if (!this.duration || !point) return 0;
				const t = Number(point.part_time) || 0;
				return Math.min(100, Math.max(0, (t / this.duration) * 100));
			},
			togglePlay() {
				const video = this.$refs.videoPlayer;
				if (!video) return;
				if (this.showTryVideo) return;
				if (video.paused) {
					video.play();
				} else {
					video.pause();
				}
				this.showControls = true;
				this.scheduleHideControls();
			},
			toggleControls() {
				this.showControls = !this.showControls;
				if (this.showControls) {
					this.scheduleHideControls();
				}
			},
			scheduleHideControls() {
				if (this.controlsTimeout) clearTimeout(this.controlsTimeout);
				// 全屏时保持控制条可见，避免按钮“消失”
				if (this.isFullscreen) return;
				this.controlsTimeout = setTimeout(() => {
					if (this.isPlaying) this.showControls = false;
				}, 3000);
			},
			onLoadedMetadata() {
				const video = this.$refs.videoPlayer;
				if (!video) return;
				this.duration = video.duration || 0;
			},
			onPlay() {
				if (this.showTryVideo) {
					const video = this.$refs.videoPlayer;
					if (video) video.pause();
					return;
				}
				this.isPlaying = true;
				this.saveProgress(50);
			},
			onEnded() {
				this.isPlaying = false;
				if (!this.showTryVideo) {
					this.saveProgress(100);
				}
			},
			async saveProgress(persent) {
				if (!this.chapterId || this.isBuy != 1) return;
				try {
					const config = this.token ? { headers: { 'X-Access-Token': this.token } } : undefined;
					await putUserChapter({
						uuid: this.chapterId,
						persent
					}, config);
				} catch (e) {
					console.warn('学习进度保存失败', e);
				}
			},
			onTimeUpdate() {
				const video = this.$refs.videoPlayer;
				if (!video) return;
				this.currentTime = video.currentTime || 0;
				this.checkTryWatch(this.currentTime);
				if (!this.showTryVideo) {
					this.checkPoints(this.currentTime);
				}
			},
			checkTryWatch(currentTime) {
				if (!this.trySeconds || this.showTryVideo) return;
				if (currentTime >= this.trySeconds) {
					const video = this.$refs.videoPlayer;
					if (video) {
						video.pause();
						video.currentTime = this.trySeconds;
					}
					this.currentTime = this.trySeconds;
					this.showTryVideo = true;
					this.isPlaying = false;
					this.showDescTip = false;
				}
			},
			checkPoints(currentTime) {
				if (!this.points.length) return;
				this.points.forEach((point, index) => {
					const t = Number(point.part_time);
					if (isNaN(t)) return;
					const key = String(index);
					const inRange = Math.abs(currentTime - t) < 0.4;
					if (inRange && !this.triggeredPoints[key]) {
						this.$set(this.triggeredPoints, key, true);
						this.showDesc(point.desc || point.name || '');
					} else if (!inRange && this.triggeredPoints[key]) {
						this.$set(this.triggeredPoints, key, false);
					}
				});
			},
			showDesc(text) {
				if (!text) return;
				if (this.tooltipTimeout) clearTimeout(this.tooltipTimeout);
				this.currentDesc = text;
				this.showDescTip = true;
				this.tooltipTimeout = setTimeout(() => {
					this.showDescTip = false;
					this.tooltipTimeout = null;
				}, 5000);
			},
			seekByClick(e) {
				if (this.showTryVideo) return;
				const wrap = this.$refs.progressWrap;
				const video = this.$refs.videoPlayer;
				if (!wrap || !video || !this.duration) return;
				const rect = wrap.getBoundingClientRect();
				const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
				let target = ratio * this.duration;
				if (this.trySeconds > 0 && target > this.trySeconds) {
					target = this.trySeconds;
				}
				video.currentTime = target;
				this.currentTime = video.currentTime;
			},
			seekToPoint(point) {
				if (this.showTryVideo) return;
				const video = this.$refs.videoPlayer;
				if (!video) return;
				let t = Number(point.part_time) || 0;
				if (this.trySeconds > 0 && t > this.trySeconds) {
					t = this.trySeconds;
				}
				video.currentTime = t;
				this.currentTime = t;
				this.showDesc(point.desc || point.name || '');
			},
			toggleFullscreen() {
				if (this.isFullscreen) {
					this.exitFullscreen();
				} else {
					this.enterFullscreen();
				}
			},
			async enterFullscreen() {
				const wrap = this.$refs.playerWrap;
				const video = this.$refs.videoPlayer;
				if (!wrap) return;

				try {
					if (video && video.paused) {
						await video.play();
					}
				} catch (e) {}

				// 对容器全屏，保留红点 / desc；不旋转画面，跟随手机当前方向
				let enteredNative = false;
				try {
					if (wrap.requestFullscreen) {
						await wrap.requestFullscreen();
						enteredNative = true;
					} else if (wrap.webkitRequestFullscreen) {
						await wrap.webkitRequestFullscreen();
						enteredNative = true;
					}
				} catch (e) {
					enteredNative = false;
				}

				this.useCssFullscreen = !enteredNative;
				this.isFullscreen = true;
				this.showControls = true;
				this.lockBodyScroll();
			},
			async exitFullscreen() {
				await this.exitDocumentFullscreen();
				this.useCssFullscreen = false;
				this.isFullscreen = false;
				this.unlockBodyScroll();
				this.showControls = true;
				this.scheduleHideControls();
			},
			async exitDocumentFullscreen() {
				try {
					if (document.fullscreenElement || document.webkitFullscreenElement) {
						if (document.exitFullscreen) {
							await document.exitFullscreen();
						} else if (document.webkitExitFullscreen) {
							await document.webkitExitFullscreen();
						}
					}
				} catch (e) {}
			},
			onFullscreenChange() {
				const active = !!(document.fullscreenElement || document.webkitFullscreenElement);
				if (!active && this.isFullscreen && !this.useCssFullscreen) {
					this.isFullscreen = false;
					this.unlockBodyScroll();
					this.showControls = true;
					this.scheduleHideControls();
				}
			},
			lockBodyScroll() {
				document.documentElement.style.overflow = 'hidden';
				document.body.style.overflow = 'hidden';
			},
			unlockBodyScroll() {
				document.documentElement.style.overflow = '';
				document.body.style.overflow = '';
			},
			clearTimers() {
				if (this.tooltipTimeout) clearTimeout(this.tooltipTimeout);
				if (this.controlsTimeout) clearTimeout(this.controlsTimeout);
			}
		}
	};
</script>

<style lang="less" scoped>
	.h5-video-page {
		min-height: 100vh;
		background: #fff;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.info {
		position: sticky;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
		flex-shrink: 0;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding: calc(16px + env(safe-area-inset-top)) 16px 16px;
		background: #fff;
		border-bottom: 1px solid #D8F0DE;

		.info-main {
			flex: 1;
			min-width: 0;
			padding-right: 12px;
		}

		.mine-btn {
			flex-shrink: 0;
			height: 28px;
			margin-top: 2px;
			width: auto;
			display: block;
			cursor: pointer;
		}

		.cate {
			display: inline-block;
			margin-bottom: 8px;
			padding: 2px 8px;
			font-size: 12px;
			font-weight: 500;
			color: #10B649;
			background: #E8F8EC;
			border: 1px solid #D8F0DE;
			border-radius: 4px;
			line-height: 1.4;
			max-width: 100%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.name {
			font-size: 18px;
			font-weight: 600;
			color: #1D2129;
			line-height: 1.4;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.sub {
			margin-top: 8px;
			font-size: 14px;
			color: #10B649;
			line-height: 1.4;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.player-area {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: flex-start;
		width: 100%;
		min-height: 0;
		box-sizing: border-box;
	}

	.player-wrap {
		position: relative;
		width: 100%;
		background: #000;
		overflow: hidden;
		flex-shrink: 0;
	}

	.bottom-banner {
		display: block;
		width: 100%;
		height: auto;
		vertical-align: top;
	}

	.h5-video {
		display: block;
		width: 100%;
		height: 56.25vw;
		max-height: 70vh;
		background: #000;
		object-fit: contain;
	}

	.desc-tip {
		position: absolute;
		left: 12px;
		bottom: 64px;
		z-index: 5;
		max-width: 70%;
		padding: 10px 14px;
		background: rgba(0, 0, 0, 0.85);
		color: #fff;
		font-size: 14px;
		line-height: 1.4;
		border-radius: 6px;
		word-break: break-all;
	}

	.try-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 8;
		background: rgba(0, 0, 0, 0.56);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding: 0 24px;

		.try-text {
			font-size: 18px;
			font-weight: 500;
			color: #fff;
			line-height: 1.6;
		}

		.try-text + .try-text {
			margin-top: 8px;
			font-size: 15px;
			font-weight: 400;
		}
	}

	.controls {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 6;
		padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 100%);
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.2s ease;

		&.controls-show {
			opacity: 1;
			pointer-events: auto;
		}
	}

	.controls-row {
		display: flex;
		align-items: center;
	}

	.play-btn,
	.fs-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 13px;
		flex-shrink: 0;
		cursor: pointer;
		user-select: none;
	}

	.play-btn {
		width: 28px;
		height: 28px;
		font-size: 14px;
	}

	.fs-btn {
		min-width: 36px;
		height: 28px;
		padding: 0 4px;
		white-space: nowrap;
	}

	.time {
		margin: 0 8px;
		color: #fff;
		font-size: 12px;
		flex-shrink: 0;
		font-variant-numeric: tabular-nums;
	}

	.progress-wrap {
		flex: 1;
		height: 24px;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.progress-bg {
		position: relative;
		width: 100%;
		height: 3px;
		background: rgba(255, 255, 255, 0.35);
		border-radius: 2px;
	}

	.progress-bar {
		height: 100%;
		background: #fff;
		border-radius: 2px;
	}

	.point-dot {
		position: absolute;
		top: 50%;
		width: 8px;
		height: 8px;
		margin-left: -4px;
		margin-top: -4px;
		background: #FF3B30;
		border: 1.5px solid #fff;
		border-radius: 50%;
		box-sizing: border-box;
		z-index: 2;
	}

	.empty {
		padding: 80px 16px;
		text-align: center;
		font-size: 14px;
		color: #999;
	}

	/* 全屏铺满当前屏幕方向，不强制旋转视频 */
	.player-wrap.is-fullscreen {
		position: fixed !important;
		top: 0 !important;
		left: 0 !important;
		right: 0 !important;
		bottom: 0 !important;
		width: 100% !important;
		height: 100% !important;
		max-width: none !important;
		max-height: none !important;
		transform: none !important;
		z-index: 9999;
		background: #000;
		display: block;
		overflow: hidden;

		.h5-video {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			max-height: none;
			object-fit: contain;
		}

		.desc-tip {
			bottom: 72px;
			left: 20px;
			max-width: 60%;
		}

		.controls {
			opacity: 1 !important;
			pointer-events: auto !important;
		}
	}
</style>
